import { Pipe, PipeTransform } from "@angular/core";
import { TimeFormatService } from "../../time-format/time-format.service";

@Pipe({ name: "alertDuration" })
export class AlertDurationPipe implements PipeTransform {
  constructor(private timeFormatService: TimeFormatService) {}

  public transform(alert: any) {
    const start = new Date(alert.params.time);
    const end = new Date(alert.params.endTime);
    return this.timeFormatService.timeFor(end.getTime() - start.getTime());
  }
}
